import angular from 'angular';

angular.module('cloudX').directive('elastic', [
  '$timeout',
  function($timeout) {
    return {
      restrict: 'A',
      scope: false,
      link: function($scope, element, attr) {
        $scope.initialHeight = $scope.initialHeight || element[0].style.height;
        var resize = function() {
          element[0].style.height = $scope.initialHeight;
          element[0].style.height = '' + (element[0].scrollHeight + 12) + 'px';
        };
        element.on('input change', resize);

        var watchVisibility = function(reverse) {
          return function(expr) {
            $scope.$watch(expr, function(val) {
              if ((reverse && !val) || (!reverse && val)) $timeout(resize, 100);
            });
          };
        };

        //Put ng-show or ng-hide on element itself to resize if visibility changes
        //
        if (angular.isDefined(attr.ngShow)) attr.$observe('ngShow', watchVisibility(false));
        if (angular.isDefined(attr.ngHide)) attr.$observe('ngHide', watchVisibility(true));

        $timeout(resize, 100);
      },
    };
  },
]);
